import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemText,
  Divider,
  Typography,
  List,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CcpAdminLinks = () => {
  const theme = useTheme();

  return (
    <>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/Admin-users">
          <ListItemText
            primary="Admin Users"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/SchoolUsers">
          <ListItemText
            primary="School Users"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <Divider />
      <List component="div" disablePadding>
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: "#fff",
            backgroundColor: "#AC1A2F",
            padding: 1,
            borderRadius: 1,
          }}
        >
          App Settings
        </Typography>
        <ListItem
          component={Link}
          to="/CcpAdminAnnouncements"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Announcements" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminArchivedData"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Archived Data" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminChangeCourseRequest"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Course Change Request" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminCoursePlanning"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Course Planning" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminDistricts"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Districts" />
        </ListItem>
        <ListItem
          component={Link}
          to="/Faqs"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="FAQs" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminForms"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Forms" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminNewCourseRequest"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="New Course Request" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminResources"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Resources" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminSchoolFeedback"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="School Feedback" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminSchools"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Schools" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminSchoolView"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="School View" />
        </ListItem>
        <ListItem
          component={Link}
          to="/CcpAdminTerm"
          sx={{ color: theme.palette.text.primary }}
        >
          <ListItemText primary="Terms" />
        </ListItem>
      </List>
    </>
  );
};

export default CcpAdminLinks;
